import common from '../common/common.js';
import { restaurantsUrl } from "../resources";

async function getAllRestaurants() {
    let url = `${restaurantsUrl}/`;
    let data;
    await common.getDataWithToken(url)
                .then(res => {
                    data = res.restaurants
                });
    console.log(data)
    return data;
}


export default {
    getAllRestaurants
}